module.exports = __webpack_public_path__ + "img/18_Cantece_campenesti_Cluj_1768.293d2fcf.jpg";